/* eslint-disable  */
import React, { Fragment, Dispatch, useEffect } from "react";
import IconButton from '@material-ui/core/IconButton';
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import NotificationIcon from "../../common/components/NotificationIcon";
import { get } from "lodash";
import XLSX from "xlsx";
import { getDeliveryDetails } from "../../store/actions/delivery.actions";
import FullscreenLoader from "../../common/components/FullscreenLoader";
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import { RESTRICTED_ACCESS } from "../../constants/restrictedAccessConstants";


const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  bodyContent: {
    color: '#666666',
    fontWeight: 600,
    fontSize: '0.75rem',
    fontFamily: 'Nunito'
  },
  tableHead: {
    color: '#133F8A',
    fontWeight: 900,
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    minWidth: 100
  },
  actionButton: {
    color: '#1A9FE0',
  },
}));

const columns = [
  {
    id: 'deliveryItem',
    label: 'S. No',
    align: 'left',
  },
  {
    id: 'materialNumber',
    label: 'Part No.',
    align: 'left'
  },
  {
    id: 'shortTextForSalesOrderItem',
    label: 'Description',
    align: 'left'
  },
  {
    id: 'actualQuantityDelivered',
    label: 'Quantity',
    align: 'left'
  },
  {
    id: 'baseUnitOfMeasure',
    label: 'Unit',
    align: 'left'
  },
];

const DeliveryDetails: React.FC = () => {
  const history = useHistory()
  const [page, setPage] = React.useState(0);
  const [open, setOpen] = React.useState(true)
  const [tableData, setTableData] = React.useState([])
  const [deliveryData, setDeliveryData] = React.useState<any>({})
  const [shippingAddress, setShippingAddress] = React.useState<any>(null);
  const [billingAddress, setBillingAddress] = React.useState<any>(null);
  const rowsPerPage = 10;
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();
  const { deliveryDetails }: any = useSelector((state: any) => state.delivery)
  const { deliveryList, viewDeliverySelected }: any = useSelector((state: any) => state.delivery);
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);


  const showDownloadOrders = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.DOWNLOAD_ORDER);
  const addresses: any = get(
    profileDetails,
    "data.data.customerInfo.addresses",
    []
  );

  // Helper function to check if an object has meaningful data
  const hasAddressData = (address: any): boolean => {
    if (!address || typeof address !== 'object') return false;

    // Check if object has any keys
    const keys = Object.keys(address);
    if (keys.length === 0) return false;

    // Check if any key has a non-empty, non-null, non-undefined value
    return keys.some(key => {
      const value = address[key];
      return value !== null &&
        value !== undefined &&
        value !== '' &&
        !(typeof value === 'object' && Object.keys(value).length === 0);
    });
  };

  useEffect(() => {
    const enquiryNumber = viewDeliverySelected?.data?.enquiryNumber;
    const deliveryNo = viewDeliverySelected?.data?.deliveryNo;
    const make = viewDeliverySelected?.data?.make;
    const orgId = viewDeliverySelected?.data?.orgId;

    // Use viewDeliverySelected directly — don't depend on deliveryList structure
    // if (enquiryNumber && deliveryNo && orgId) {
    // Get sapCustomerId from deliveryList if available, else from sessionStorage fallback
    const deliveryListData = get(deliveryList, 'data.data.deliveryList', []);
    const matchedDelivery = Array.isArray(deliveryListData)
      ? deliveryListData.find((d: any) => d.delivery === deliveryNo)
      : deliveryListData;

    const sapCustomerId = matchedDelivery?.sapCustomerId
      || sessionStorage.getItem('selectedSapCustomerId')
      || '';

    dispatch(getDeliveryDetails(enquiryNumber, deliveryNo, make, orgId, sapCustomerId));
    // } else {
    //   console.warn("Missing required params — API not called", {
    //     enquiryNumber, deliveryNo, orgId
    //   });
    // }
  }, [viewDeliverySelected]); // ✅ Only depend on viewDeliverySelected, not deliveryList

  useEffect(() => {
    // Only proceed if deliveryData has been loaded (not empty)
    // OR if addresses from profile are available
    const hasDeliveryData = Object.keys(deliveryData).length > 0;
    const hasProfileAddresses = addresses && addresses.length > 0;

    if (!hasDeliveryData && !hasProfileAddresses) {
      return; // Wait for data to load
    }

    // Check if shiftToPartyAddressDetails has meaningful data
    const shippingData = deliveryData?.shiftToPartyAddressDetails;
    const hasShippingData = hasAddressData(shippingData);

    if (hasShippingData) {
      // Use API shipping address
      setShippingAddress(shippingData);
    } else {
      // Fallback to default address from profile
      const defaultAddress = addresses?.find((addr: any) => addr.default || addr.dafault);
      setShippingAddress(defaultAddress || null);
    }

    // Set billing address from profile (default address)
    const defaultBillingAddress = addresses?.find((addr: any) => addr.default || addr.dafault);
    setBillingAddress(defaultBillingAddress || null);

  }, [addresses, deliveryData]);

  useEffect(() => {
    const list = get(deliveryList, 'data.data', []);
    const deliveryDataItem = list[0];

    if (deliveryDataItem?.delivery) {
      dispatch(
        getDeliveryDetails(
          viewDeliverySelected?.data?.enquiryNumber,
          viewDeliverySelected?.data?.deliveryNo,
          viewDeliverySelected?.data?.make,
          viewDeliverySelected?.data?.orgId,
          deliveryDataItem.sapCustomerId
        )
      );
    }
  }, [deliveryList, viewDeliverySelected]);


  useEffect(() => {
    // Check deliveryDetails first (from API call)
    const tableDataFromDetails = get(deliveryDetails, 'data.data.deliveryItem', []);
    const deliveryDataFromDetails = get(deliveryDetails, 'data.data', {});

    // Check deliveryList (new response structure)
    const deliveryDataList = get(deliveryList, 'data.data', []);

    // Priority 1: Use deliveryDetails if available (from getDeliveryDetails API call)
    if (tableDataFromDetails && tableDataFromDetails.length > 0) {
      setTableData(tableDataFromDetails);
      setDeliveryData(deliveryDataFromDetails);
    }
    // Priority 2: Use deliveryList data (new structure)
    else if (deliveryDataList && Array.isArray(deliveryDataList) && deliveryDataList.length > 0) {
      const firstDelivery = deliveryDataList[0];

      if (firstDelivery && firstDelivery.delivery) {
        // Set the delivery items from the deliveryItem array
        const items = firstDelivery.deliveryItem || [];
        setTableData(items);

        // Set the main delivery data
        setDeliveryData({
          deliveryList: {
            delivery: firstDelivery.delivery,
            enquiryNumber: viewDeliverySelected?.data?.enquiryNumber || "-",
            salesDocument: firstDelivery.salesDocument,
            description: firstDelivery.description,
            billingStatus: firstDelivery.billingStatus,
            shippingPlanningStatus: firstDelivery.shippingPlanningStatus,
            shippingPointOrreceivingPoint: firstDelivery.shippingReceivingPoint,
            pickingStatus: firstDelivery.pickingStatus,
            deliveryOverallStatus: "-", // Not in the new response
            goodsMovementStatus: firstDelivery.goodsMovementStatus,
            billingDocument: firstDelivery.billingDocument,
          },
          sapCustomerId: firstDelivery.sapCustomerId,
          customerName: firstDelivery.customerName,
          // Add shipping address if available from API
          shiftToPartyAddressDetails: firstDelivery.shiftToPartyAddressDetails || {},
        });
      }
    }
  }, [deliveryDetails, deliveryList, viewDeliverySelected]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    dispatch(getDeliveryDetails(
      deliveryData.deliveryList.enquiryNumber,
      deliveryData.deliveryList.delivery,
      viewDeliverySelected?.data?.make,
      viewDeliverySelected?.data?.orgId,
      (deliveryData && deliveryData.sapCustomerId) || sessionStorage.getItem('selectedSapCustomerId') || '',
      newPage
    ));
  };

  const handleopenClose = () => {
    setOpen(false)
    return false
  }

  const exportData = () => {
    if (tableData && Array.isArray(tableData) && tableData.length > 0) {
      let filename = "deliveryItems.xlsx";
      let data: any = [];
      tableData.map((item: any, i: any) => {
        data.push({
          'S. No': i + 1,
          'Line Item Number': item.deliveryItem || item.delivery || "-",
          PartNumber: item.materialNumber || "-",
          Description: item.shortTextForSalesOrderItem || item.description || "-",
          Quantity: item.actualQuantityDelivered != null && item.actualQuantityDelivered !== "" && !isNaN(Number(item.actualQuantityDelivered))
            ? Math.trunc(Number(item.actualQuantityDelivered))
            : "-",
          Unit: item.baseUnitOfMeasure || "-"
        });
        return undefined;
      });
      var ws = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "sheet1");
      XLSX.writeFile(wb, filename);
    }
  };

  if (deliveryDetails && deliveryDetails.loading) {
    return <FullscreenLoader />
  }

  if (deliveryDetails && deliveryDetails.err && deliveryDetails.err.statusText) {
    return (
      <Snackbar
        open={open}
        type="error"
        handleopenClose={handleopenClose}
        message={deliveryDetails.err.statusText.data.message.message ? deliveryDetails.err.statusText.data.message.message : 'There was a problem fetching the delivery list'}
      />
    )
  }

  // Helper function to safely get address field
  const getAddressField = (address: any, field: string) => {
    return address?.[field] || "-";
  };

  return (
    <Fragment>
      {deliveryList && deliveryList.loading ? <FullscreenLoader /> : <>
        <div className="d-flex align-items-center">
          <h2 className="page-title">
            Delivery Details
            <Breadcrumbs>
              <Typography color="textSecondary" className="breadcrumb-text-order-history">Order History</Typography>
              <Typography color="textSecondary" className="breadcrumb-text-order-history">Delivery List</Typography>
              <Typography color="textPrimary" className="breadcrumb-text-delivery-details">Delivery Details</Typography>
            </Breadcrumbs>
          </h2>
          <div className="ml-auto d-flex align-items-center">
            <AnnouncementIcon />
            <NotificationIcon />
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="d-flex align-items-center">
              <h5 className="page-sub-title">Delivery Details</h5>
              <IconButton onClick={() => { history.push(`/deliverylist`); setTableData([]); setDeliveryData({}) }} className={`ml-auto ${classes.actionButton}`}>
                <ChevronLeftIcon fontSize="small" />
                <span className="backLinkLabel">Back to List</span>
              </IconButton>
            </div>
          </div>
          <div className="col-12 col-lg-12 col-md-12 col-sm-12">
            <div className="cardCommon d-flex font-11">
              <div className="col-lg-12 col-md-12 col-sm-12 pt-3 pb-3 pl-4 pr-4">
                <h6 className="title mb-3">Enquiry Details</h6>
                <div className="row">
                  <div className="col-3 col-md-3 col-sm-6">
                    <div className="subTitle mb-2">Delivery No:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.delivery || "-"}</span>
                    </div>
                    <div className="subTitle mb-2">Enquiry No:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.enquiryNumber || "-"}</span>
                    </div>
                    <div className="subTitle mb-2">Created On:
                      <span className="subTitleValue">{sessionStorage.getItem('selectedOrderCreatedOn') || "-"}</span>
                    </div>
                  </div>
                  <div className="col-3 col-md-3 col-sm-3 pl-2">
                    <div className="subTitle mb-2">Invoice Status:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.billingStatus || "-"}</span>
                    </div>
                    <div className="subTitle mb-2">Order No:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.salesDocument || "-"}</span>
                    </div>
                    <div className="subTitle mb-2">Description:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.description || "-"}</span>
                    </div>
                  </div>
                  <div className="col-3 col-md-3 col-sm-3 pl-2">
                    <div className="subTitle mb-2">Shipping Plan Status:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.shippingPlanningStatus || "-"}</span>
                    </div>
                    <div className="subTitle mb-2">Shipping Receiving Point:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.shippingPointOrreceivingPoint || "-"}</span>
                    </div>
                    <div className="subTitle mb-2">Picking Status:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.pickingStatus || "-"}</span>
                    </div>
                  </div>
                  <div className="col-3 col-md-3 col-sm-3 pl-2">
                    <div className="subTitle mb-2">Overall Delivery Status:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.deliveryOverallStatus || "-"}</span>
                    </div>
                    <div className="subTitle mb-2">Goods Issue Status:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.goodsMovementStatus || "-"}</span>
                    </div>
                    <div className="subTitle mb-2">Invoice No:
                      <span className="subTitleValue">{deliveryData?.deliveryList?.billingDocument || "-"}</span>
                    </div>
                  </div>
                </div>

                {/* Shipping Address Section */}
                <h6 className="title mb-3 mt-1">Shipping Address</h6>
                {shippingAddress ? (
                  <div className="row">
                    <div className="col-4 col-md-4 col-sm-4">
                      <div className="subTitle mb-2 pr-1">
                        {getAddressField(shippingAddress, 'companyName') !== "-" ? 'Company Name:' : "Location Name:"}
                        <span className="ml-4 margin-companyName">
                          {getAddressField(shippingAddress, 'companyName') !== "-"
                            ? getAddressField(shippingAddress, 'companyName')
                            : getAddressField(shippingAddress, 'location')}
                        </span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">City:
                        <span className="ml-3">{getAddressField(shippingAddress, 'city')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">Country:
                        <span className="ml-3">{getAddressField(shippingAddress, 'country')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4">
                      <div className="subTitle mb-2 pr-1">Telephone Number:
                        <span className="ml-4 margin-telephoneNumber">{getAddressField(shippingAddress, 'telephoneNumber')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">PO Box:
                        <span className="ml-3">{getAddressField(shippingAddress, 'poBox')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">Emirates/Region:
                        <span className="ml-3">
                          {getAddressField(shippingAddress, 'region')} {getAddressField(shippingAddress, 'city')}
                        </span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4">
                      <div className="subTitle mb-2">Transportation Zone:
                        <span className="ml-2">{getAddressField(shippingAddress, 'transportationZone')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">Ship to party no:
                        <span className="ml-2">{getAddressField(shippingAddress, 'shiftToPartyCustomerNumber')}</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <p>No shipping address available</p>
                    </div>
                  </div>
                )}

                {/* Billing Address Section */}
                <h6 className="title mb-3 mt-1">Billing Address</h6>
                {billingAddress ? (
                  <div className="row">
                    <div className="col-4 col-md-4 col-sm-4">
                      <div className="subTitle mb-2 pr-1">Company Name:
                        <span className="ml-4 margin-companyName">{getAddressField(billingAddress, 'companyName')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">City:
                        <span className="ml-3">{getAddressField(billingAddress, 'city')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">Country:
                        <span className="ml-3">{getAddressField(billingAddress, 'country')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4">
                      <div className="subTitle mb-2 pr-1">Telephone Number:
                        <span className="ml-4 margin-telephoneNumber">{getAddressField(billingAddress, 'telephoneNumber')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">PO Box:
                        <span className="ml-3">{getAddressField(billingAddress, 'poBox')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">Emirates/Region:
                        <span className="ml-3">
                          {getAddressField(billingAddress, 'region')} {getAddressField(billingAddress, 'city')}
                        </span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4">
                      <div className="subTitle mb-2">Transportation Zone:
                        <span className="ml-2">{getAddressField(billingAddress, 'transportationZone')}</span>
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-sm-4 pl-2">
                      <div className="subTitle mb-2">Ship to party no:
                        <span className="ml-2">{getAddressField(billingAddress, 'shiftToPartyCustomerNumber')}</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <p>No billing address available</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="d-flex align-items-center">
              <h5 className="page-sub-title">Delivery Items</h5>
              {showDownloadOrders && (
                <div className="exportExcel ml-auto" onClick={() => exportData()} style={{ cursor: 'pointer' }}>
                  <IconButton className="exportExcel" size="small" >
                    <ArrowDownwardIcon fontSize="inherit" />
                  </IconButton>
                  Export to Excel
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-12 col-md-12 col-sm-12">
            <div className="cardCommon orderItems">
              <TableContainer className={`classes.container`}>
                <Table aria-label="table" >
                  <TableHead className="w-100">
                    <TableRow>
                      <TableCell className={classes.tableHead}>S. No</TableCell>
                      <TableCell className={classes.tableHead}>Line Item Number</TableCell>
                      <TableCell className={classes.tableHead}>Part No.</TableCell>
                      <TableCell className={classes.tableHead}>Description</TableCell>
                      <TableCell className={classes.tableHead}>Quantity</TableCell>
                      <TableCell className={classes.tableHead}>Unit</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row: any, index: number) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className={classes.bodyContent}>
                            {page * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className={classes.bodyContent}>
                            {row.deliveryItem || row.delivery || "-"}
                          </TableCell>
                          <TableCell className={classes.bodyContent}>
                            {row.materialNumber || "-"}
                          </TableCell>
                          <TableCell className={classes.bodyContent}>
                            {row.shortTextForSalesOrderItem || row.description || "-"}
                          </TableCell>
                          <TableCell className={classes.bodyContent}>
                            {row.actualQuantityDelivered != null ? Math.trunc(Number(row.actualQuantityDelivered)) : "-"}
                          </TableCell>
                          <TableCell className={classes.bodyContent}>
                            {row.baseUnitOfMeasure || "-"}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className="col-12 d-flex justify-content-end">
                <TablePagination
                  rowsPerPageOptions={[10]}
                  component="div"
                  count={tableData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </div>
            </div>
          </div>
        </div>
      </>}
    </Fragment>
  );
};

export default DeliveryDetails;